/**
 * @desc 转移预占数量
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.TransferPreemptionQtyDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/transfer/preemptionQty`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
